module.exports = __webpack_public_path__ + "static/img/123.da149ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/123.png
// module id = cX0Y
// module chunks = 0